/* ==========================================================================
   Maison Léonie — comportements du thème
   Panier AJAX Shopify, menu mobile, onglets et variantes de la fiche produit.
   ========================================================================== */

(function () {
  "use strict";

  var DRAWER_SECTION = "cart-drawer";

  /* ---------------------------------------------------------------- utils */

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function getDrawer() { return qs("[data-cart-drawer]"); }

  function setCartCount(value) {
    qsa("[data-cart-count]").forEach(function (el) { el.textContent = value; });
  }

  /* Remplace le contenu du tiroir par le HTML renvoyé par la Section Rendering API */
  function renderDrawer(sectionHtml) {
    if (!sectionHtml) return;
    var parsed = new DOMParser().parseFromString(sectionHtml, "text/html");
    var fresh = qs("[data-cart-drawer]", parsed);
    var current = getDrawer();
    if (!fresh || !current) return;
    var wasOpen = !current.hasAttribute("hidden");
    current.innerHTML = fresh.innerHTML;
    if (wasOpen) current.removeAttribute("hidden");
    var count = fresh.getAttribute("data-cart-count");
    if (count !== null) setCartCount(count);
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.removeAttribute("hidden");
    document.documentElement.style.overflow = "hidden";
    var close = qs("[data-cart-close]", drawer);
    if (close) close.focus();
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.setAttribute("hidden", "");
    document.documentElement.style.overflow = "";
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* ------------------------------------------------------------ opérations */

  function addItems(items, shouldOpen) {
    return postJSON("/cart/add.js", { items: items, sections: DRAWER_SECTION })
      .then(function (data) {
        if (data && data.sections) renderDrawer(data.sections[DRAWER_SECTION]);
        else return refreshDrawer();
      })
      .then(function () { if (shouldOpen !== false) openDrawer(); })
      .catch(function () { window.location.href = "/cart"; });
  }

  function changeLine(line, quantity) {
    return postJSON("/cart/change.js", {
      line: line,
      quantity: quantity,
      sections: DRAWER_SECTION
    }).then(function (data) {
      if (data && data.sections) renderDrawer(data.sections[DRAWER_SECTION]);
    });
  }

  function refreshDrawer() {
    return fetch("/?sections=" + DRAWER_SECTION)
      .then(function (r) { return r.json(); })
      .then(function (data) { renderDrawer(data[DRAWER_SECTION]); });
  }

  /* -------------------------------------------------------- délégation DOM */

  document.addEventListener("click", function (event) {
    var el;
    if (!event.target || typeof event.target.closest !== "function") return;

    /* Ouvrir / fermer le panier */
    if ((el = event.target.closest("[data-cart-toggle]"))) {
      event.preventDefault();
      openDrawer();
      return;
    }
    if (event.target.closest("[data-cart-close]") || event.target.closest("[data-cart-overlay]")) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    /* Ajout depuis une carte produit ou la fiche best-seller */
    if ((el = event.target.closest("[data-add-variant]"))) {
      event.preventDefault();
      var id = el.getAttribute("data-add-variant");
      if (!id) return;
      var quantity = parseInt(el.getAttribute("data-add-quantity") || "1", 10);
      el.disabled = true;
      addItems([{ id: Number(id), quantity: quantity }]).then(function () { el.disabled = false; });
      return;
    }

    /* Ajout du coffret : plusieurs variantes d'un coup */
    if ((el = event.target.closest("[data-add-bundle]"))) {
      event.preventDefault();
      var ids = (el.getAttribute("data-add-bundle") || "").split(",").filter(Boolean);
      if (!ids.length) return;
      el.disabled = true;
      addItems(ids.map(function (v) { return { id: Number(v), quantity: 1 }; }))
        .then(function () { el.disabled = false; });
      return;
    }

    /* Quantités dans le tiroir */
    if ((el = event.target.closest("[data-line-change]"))) {
      event.preventDefault();
      changeLine(
        parseInt(el.getAttribute("data-line"), 10),
        parseInt(el.getAttribute("data-line-change"), 10)
      );
      return;
    }

    /* Menu mobile */
    if ((el = event.target.closest("[data-menu-toggle]"))) {
      event.preventDefault();
      var nav = qs("[data-mobile-nav]");
      if (!nav) return;
      var open = nav.hasAttribute("hidden");
      if (open) nav.removeAttribute("hidden"); else nav.setAttribute("hidden", "");
      el.setAttribute("aria-expanded", open ? "true" : "false");
      var icon = qs("span", el);
      if (icon) icon.textContent = open ? "✕" : "☰";
      return;
    }

    /* Onglets de la fiche produit */
    if ((el = event.target.closest("[data-tab]"))) {
      event.preventDefault();
      var name = el.getAttribute("data-tab");
      qsa("[data-tab]").forEach(function (t) { t.classList.toggle("is-active", t === el); });
      qsa("[data-panel]").forEach(function (p) {
        if (p.getAttribute("data-panel") === name) p.removeAttribute("hidden");
        else p.setAttribute("hidden", "");
      });
      return;
    }

    /* Sélection de variante sur la fiche produit */
    if ((el = event.target.closest("[data-variant]"))) {
      event.preventDefault();
      selectVariant(el);
      return;
    }

    /* Quantité sur la fiche produit */
    if ((el = event.target.closest("[data-qty-step]"))) {
      event.preventDefault();
      var input = qs("[data-qty-input]");
      var display = qs("[data-qty-display]");
      if (!input) return;
      var next = Math.max(1, parseInt(input.value, 10) + parseInt(el.getAttribute("data-qty-step"), 10));
      input.value = next;
      if (display) display.textContent = next;
      updateAddButton();
      return;
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeDrawer();
  });

  /* ------------------------------------------------------- fiche produit */

  function selectVariant(button) {
    qsa("[data-variant]").forEach(function (b) { b.classList.toggle("is-active", b === button); });

    var id = button.getAttribute("data-variant");
    var price = button.getAttribute("data-variant-price");
    var available = button.getAttribute("data-variant-available") === "true";

    var input = qs("[data-variant-input]");
    if (input) input.value = id;

    var priceEl = qs("[data-product-price]");
    if (priceEl && price) priceEl.textContent = price;

    var form = qs("[data-product-form]");
    if (form) form.setAttribute("data-available", available ? "true" : "false");

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", id);
      history.replaceState({}, "", url.toString());
    }

    updateAddButton();
  }

  /* Met à jour le libellé « Ajouter au panier · XX € » */
  function updateAddButton() {
    var button = qs("[data-add-label]");
    if (!button) return;

    var form = qs("[data-product-form]");
    var available = !form || form.getAttribute("data-available") !== "false";
    var input = qs("[data-qty-input]");
    var qty = input ? parseInt(input.value, 10) : 1;

    var active = qs("[data-variant].is-active");
    var cents = active
      ? parseInt(active.getAttribute("data-variant-cents"), 10)
      : parseInt(button.getAttribute("data-unit-cents"), 10);

    if (!available) {
      button.textContent = button.getAttribute("data-sold-out-label") || "Épuisé";
      button.disabled = true;
      return;
    }

    button.disabled = false;
    button.textContent =
      (button.getAttribute("data-add-label") || "Ajouter au panier") +
      " · " + formatMoney(cents * qty);
  }

  /* Formatage monétaire aligné sur la devise de la boutique */
  function formatMoney(cents) {
    var settings = window.LeonieTheme || {};
    var amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(settings.locale || "fr-FR", {
        style: "currency",
        currency: settings.currency || "EUR"
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2).replace(".", ",") + " €";
    }
  }

  /* Soumission AJAX du formulaire produit */
  document.addEventListener("submit", function (event) {
    if (!event.target || typeof event.target.closest !== "function") return;
    var form = event.target.closest("[data-product-form]");
    if (!form) return;
    event.preventDefault();

    var variant = qs("[data-variant-input]", form);
    var qty = qs("[data-qty-input]", form);
    if (!variant || !variant.value) return;

    var button = qs("[data-add-label]", form);
    if (button) button.disabled = true;

    addItems([{ id: Number(variant.value), quantity: qty ? Number(qty.value) : 1 }])
      .then(function () { if (button) button.disabled = false; });
  });

  /* ------------------------------------------------------------ init */

  document.addEventListener("DOMContentLoaded", function () {
    updateAddButton();

    /* Ouvre le tiroir si l'URL contient ?cart=open */
    if (new URLSearchParams(window.location.search).get("cart") === "open") openDrawer();
  });
})();

/* ==========================================================================
   Mode autonome : fenêtres produit + pages directement intégrées au thème
   ========================================================================== */
(function () {
  "use strict";

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function lockPage(locked) {
    document.documentElement.style.overflow = locked ? "hidden" : "";
  }

  function closeDemoModal() {
    var modal = qs("[data-demo-modal]");
    if (!modal) return;
    modal.setAttribute("hidden", "");
    lockPage(false);
  }

  function openDemoModal(trigger) {
    var modal = qs("[data-demo-modal]");
    if (!modal || !trigger) return;
    var image = qs("[data-demo-modal-image]", modal);
    var title = qs("[data-demo-modal-title]", modal);
    var price = qs("[data-demo-modal-price]", modal);
    var tagline = qs("[data-demo-modal-tagline]", modal);
    var description = qs("[data-demo-modal-description]", modal);

    if (image) {
      image.src = trigger.getAttribute("data-demo-image") || image.src;
      image.alt = trigger.getAttribute("data-demo-title") || "Produit Maison Léonie";
    }
    if (title) title.textContent = trigger.getAttribute("data-demo-title") || "Maison Léonie";
    if (price) price.textContent = trigger.getAttribute("data-demo-price") || "";
    if (tagline) tagline.textContent = trigger.getAttribute("data-demo-tagline") || "Le rituel Maison Léonie";
    if (description) description.textContent = trigger.getAttribute("data-demo-description") || "";

    modal.removeAttribute("hidden");
    lockPage(true);
    var close = qs("[data-demo-close]", modal);
    if (close) close.focus();
  }

  function closePageModal(clearHash) {
    var modal = qs("[data-page-modal]");
    if (!modal) return;
    modal.setAttribute("hidden", "");
    lockPage(false);
    if (clearHash && history.replaceState && window.location.hash) {
      history.replaceState({}, "", window.location.pathname + window.location.search);
    }
  }

  function openPageModal(name, updateHash) {
    var modal = qs("[data-page-modal]");
    var content = qs("[data-page-content]", modal);
    var template = qs('[data-page-template="' + name + '"]');
    if (!modal || !content || !template) return false;

    content.innerHTML = "";
    content.appendChild(template.content.cloneNode(true));
    modal.removeAttribute("hidden");
    lockPage(true);

    if (updateHash !== false && history.replaceState) {
      history.replaceState({}, "", "#" + name);
    }
    var close = qs("[data-page-close]", modal);
    if (close) close.focus();
    return true;
  }

  document.addEventListener("click", function (event) {
    if (!event.target || typeof event.target.closest !== "function") return;

    var demo = event.target.closest("[data-demo-product]");
    if (demo) {
      event.preventDefault();
      closePageModal(false);
      openDemoModal(demo);
      return;
    }

    if (event.target.closest("[data-demo-close]")) {
      event.preventDefault();
      closeDemoModal();
      return;
    }

    var pageTrigger = event.target.closest("[data-page-open]");
    if (pageTrigger) {
      event.preventDefault();
      closeDemoModal();
      openPageModal(pageTrigger.getAttribute("data-page-open"), true);
      return;
    }

    if (event.target.closest("[data-page-close]")) {
      event.preventDefault();
      closePageModal(true);
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    closeDemoModal();
    closePageModal(true);
  });

  document.addEventListener("DOMContentLoaded", function () {
    var pageName = (window.location.hash || "").replace(/^#/, "");
    if (pageName) openPageModal(pageName, false);
  });
})();
